// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
// COMPONENTS
// ICONS
import { CgClose } from 'react-icons/cg';
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import TextAreaBlock from '../../components/TextAreaBlock';
import FileUploadBlock from '../../components/FileUploadBlock';
import Button from '../../components/Button';
import TextEditorBlock from '../../components/TextEditorBlock';
import LoadingScreen from '../../components/LoadingScreen';
// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import * as SalesToolService from '../../services/salestool.service';
import SalesToolValidator from '../../helpers/validators/sales-management/SalesToolCreateValidator';
import constants from '../../constants/constants';

var timeoutId = 0;

const CreateNewSalesToolPage = (props) => {
    const role = Helper.LoggedInUserRole();

    const [emailBody, setEmailBody] = useState("");
    const [weeklySalesTalkingPoints, setWeeklySalesTalkingPoints] = useState("");

    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [salesToolId, setSalesToolId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const initialState = {
        id: salesToolId,
        name: "",
        description: "",
        availableOn: "",
        availableUntil: "",
        videoFile: [],
        videoPath: "",
        weeklySalesTalkingPoints: "",
        emailSubject: "",
        emailBody: ""
    };

    const [loading, setLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isUsed, setIsUsed] = useState(false);

    const [salesTool, setSalesTool] = useState(initialState);

    const [videoFile, setVideoFile] = useState(null);
    const [videoPath, setVideoPath] = useState(null);

    useEffect(() => {
        if (salesToolId > 0) {
            setLoading(true);
            SalesToolService.Get(salesToolId).then(res => {
                setSalesTool(res);
                setEmailBody(res.emailBody);
                setWeeklySalesTalkingPoints(res.weeklySalesTalkingPoints);
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
    }, [])

    const checkName = (e) => {
        clearTimeout(timeoutId);
        setIsChecking(true);
        timeoutId = setTimeout(() => {
            formik.setFieldTouched('name');
            if (e != undefined && e.target.value == salesTool.name) {
                setIsUsed(false);
                setIsChecking(false);
            }
            else
                SalesToolService.Check(e == undefined ? formik.values.name : e.target.value).then(res => {
                    console.log('finished');
                    setIsUsed(res);
                    setIsChecking(false);
                });
        }, 300);
    }

    const DeleteSalesToolVideo = (key) => {
        SalesToolService.DeleteSalesToolVideo(salesToolId, key)
            .then(res => {
                Alert({success: true, message: 'Video has been removed!'});
            }).catch(ex => {});
    }

    const CreateSalesTool = (values, setSubmitting) => {
        if (isUsed)
            return;
        //setLoading(true);
        setSubmitting(true);
        SalesToolService.Save(Helper.ConvertJsonToFormData({
            ...values,
            videoPath: videoPath,
            videoFile: videoFile ? videoFile[0].file : null
        })).then(res => {
            setSalesToolId(res);
            setSubmitting(false);
            setLoading(false);
            Alert({ success: true, message: "Sales Tool has been saved!" });
        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
        });
    }

    const formik = useFormik({
        initialValues: salesTool,
        enableReinitialize: true,
        validationSchema: SalesToolValidator,
        onSubmit: (values, { setSubmitting }) => {
            console.log(weeklySalesTalkingPoints);
            console.log(emailBody);
            CreateSalesTool({ ...values, weeklySalesTalkingPoints: weeklySalesTalkingPoints, emailBody: emailBody }, setSubmitting);
        }
    })

    return (
        <>

            {
                loading ?
                    <LoadingScreen /> :

                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style content">
                                <ContentHeader
                                    title={(salesToolId > 0 ? "Update" : "Add New") + " Sales Tool"}
                                    headerSize="sm"
                                />
                                <FormBlock onSubmit={formik.handleSubmit}>
                                    <Section removeContainer>
                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="name"
                                                inputLabel="Sales Tool Name"
                                                bordered
                                                {...formik.getFieldProps("name")}
                                                inputState={
                                                    formik.touched.name && (formik.errors.name || isUsed)
                                                        ? "error"
                                                        : formik.touched.name && formik.errors.name == null && !isUsed ? "success" : ""
                                                }
                                                errorMessage={isUsed ? "Name is already in use!" : formik.errors.name}
                                                onKeyUp={checkName}
                                                loading={isChecking}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={3}>
                                            <InputBlock
                                                inputLabel="Available On"
                                                bordered
                                                type="date"
                                                clearAction={formik.values.availableOn != null}
                                                clearActionOnClick={() => { formik.setFieldValue("availableOn", null) }}
                                                options={{ dateFormat: "m-d-Y" }}
                                                value={formik.getFieldProps("availableOn").value ? Helper.FormatToUSDate(formik.getFieldProps("availableOn").value) : ""}
                                                onChange={date => {
                                                    formik.setFieldValue("availableOn", Helper.FormatToUSDate(date[0]));
                                                    formik.setFieldTouched("availableOn");
                                                }}
                                                inputState={
                                                    formik.touched.availableOn && formik.errors.availableOn
                                                        ? "error"
                                                        : formik.touched.availableOn && formik.errors.availableOn == null ? "success" : ""
                                                }
                                                errorMessage={formik.errors.availableOn}
                                            />
                                        </ContentBlock>


                                        <ContentBlock cols={3}>
                                            <InputBlock
                                                inputLabel="Available Until"
                                                bordered
                                                type="date"
                                                clearAction={formik.values.availableUntil != null}
                                                clearActionOnClick={() => { formik.setFieldValue("availableUntil", null) }}
                                                options={{ dateFormat: "m-d-Y" }}
                                                value={formik.getFieldProps("availableUntil").value ? Helper.FormatToUSDate(formik.getFieldProps("availableUntil").value) : ""}
                                                //onBlur={() => formik.setFieldTouched("availableUntil")}
                                                onChange={date => {
                                                    formik.setFieldValue("availableUntil", Helper.FormatToUSDate(date[0]));
                                                    formik.setFieldTouched("availableUntil");
                                                }}
                                                inputState={
                                                    formik.touched.availableUntil && formik.errors.availableUntil
                                                        ? "error"
                                                        : formik.touched.availableUntil && formik.errors.availableUntil == null ? "success" : ""
                                                }
                                                errorMessage={formik.errors.availableUntil}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextAreaBlock
                                                id="description"
                                                inputLabel="Description"
                                                bordered
                                                {...formik.getFieldProps("description")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <FileUploadBlock
                                                clearAction
                                                type='video'
                                                setVideoPath={setVideoPath}
                                                videoUrl={salesTool?.videoPath}
                                                labelIdle='Upload Sales Video (Optional)'
                                                onupdatefiles={setVideoFile}
                                                onClick={DeleteSalesToolVideo}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextEditorBlock
                                                id="weeklySalesTalkingPoints"
                                                name="weeklySalesTalkingPoints"
                                                inputLabel="Weekly Sales Talking Points"
                                                bordered
                                                value={salesTool.weeklySalesTalkingPoints}
                                                changeText={setWeeklySalesTalkingPoints}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <InputBlock
                                                id="emailSubject"
                                                inputLabel="Email Subject"
                                                bordered
                                                {...formik.getFieldProps("emailSubject")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextEditorBlock
                                                id="emailBody"
                                                name="emailBody"
                                                inputLabel="Email Body"
                                                bordered
                                                value={salesTool.emailBody}
                                                changeText={setEmailBody}
                                            />
                                        </ContentBlock>

                                        <CustomBlock className="content-container--actions">
                                            <Button
                                                text="Cancel"
                                                to="/sales-tools"
                                                className="danger--bg fit-content"
                                            />
                                            <Button
                                                text="Save"
                                                type="submit"
                                                loading={formik.isSubmitting}
                                                disabled={formik.isSubmitting}
                                                className="success--bg fit-content"
                                            />
                                        </CustomBlock>
                                    </Section>
                                </FormBlock>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    );
}

export default CreateNewSalesToolPage;